"use client";
import withWatchlist from "src/components/filmwebid/withWatchlist";
import Poster from "src/components/posterrow/Poster";

const PosterWithWatchlist = withWatchlist(Poster, "film");

export default PosterWithWatchlist;
